/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */
import { Injectable } from '@angular/core';
import { SupplierUserContext } from '@gh/supplier-shared';
import { SupplierInvoicesRestService } from '@gh/supplier-shared-data';
import * as i0 from "@angular/core";
import * as i1 from "@gh/supplier-shared";
import * as i2 from "@gh/supplier-shared-data";
var SupplierInvoicesListBusinessService = /** @class */ (function () {
    function SupplierInvoicesListBusinessService(userContext, restService) {
        this.userContext = userContext;
        this.restService = restService;
    }
    SupplierInvoicesListBusinessService.prototype.getAll = function () {
        return this.restService.getAll();
    };
    SupplierInvoicesListBusinessService.prototype.delete = function (id) {
        return this.restService.delete(id);
    };
    SupplierInvoicesListBusinessService.ɵfac = function SupplierInvoicesListBusinessService_Factory(t) { return new (t || SupplierInvoicesListBusinessService)(i0.ɵɵinject(i1.SupplierUserContext), i0.ɵɵinject(i2.SupplierInvoicesRestService)); };
    SupplierInvoicesListBusinessService.ɵprov = i0.ɵɵdefineInjectable({ token: SupplierInvoicesListBusinessService, factory: SupplierInvoicesListBusinessService.ɵfac });
    return SupplierInvoicesListBusinessService;
}());
export { SupplierInvoicesListBusinessService };
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(SupplierInvoicesListBusinessService, [{
        type: Injectable
    }], function () { return [{ type: i1.SupplierUserContext }, { type: i2.SupplierInvoicesRestService }]; }, null); })();
